export class LinkedAppliedAcrossModel {
    currentID: number;
    linkedAppliesAcrossIds: Array<number>;

    constructor() {
        this.currentID = 0;
        this.linkedAppliesAcrossIds = [];
    }
}